 <!-- DESCRICAO -->
 <mat-toolbar class="titulopartes">Descrição</mat-toolbar>
 <div fxLayout="row" style="margin-bottom: 20px">
     <mat-form-field class="topo" style="margin-left: 20px" fxFlex="100%" appearance="outline">
        <mat-label>Descrição da Atividade:</mat-label>
        <textarea matInput #message name="descricao" cdkTextareaAutosize #autosize="cdkTextareaAutosize"
            cdkAutosizeMinRows="3" maxlength="4000" [(ngModel)]="atividade.descricao" [disabled]="campoDesabilitado">
             </textarea>
        <mat-hint align="end">{{message.value.length}} / 4000</mat-hint>
    </mat-form-field>
 </div>
 <div fxLayout="row" style="margin-bottom: 20px">
    <!-- <div fxLayout="column" fxFlex="46%">
        <div fxLayout="row" fxLayoutGap="25px" fxFlexFill>
            <mat-form-field style="margin: 0 0 0 20px" fxFlex="100" appearance="outline">
                <mat-label>Público Alvo:</mat-label>
                <textarea #publicoAlvo matInput name="publicoAlvo" [(ngModel)]="atividade.descricaoPublicoAlvo" cdkTextareaAutosize
                    #autosize="cdkTextareaAutosize" cdkAutosizeMinRows="8" maxlength="200" [disabled]="campoDesabilitado"></textarea>
                    <mat-hint align="end">{{publicoAlvo.value.length}} / 200</mat-hint>
            </mat-form-field>
        </div>
    </div> -->
    <div fxLayout="column" fxFlex="46%">
        <mat-form-field class="topo" style="margin: 0 0 0 20px" fxFlex="100" appearance="outline">
            <mat-label>Metodologia / Atividades:</mat-label>
            <textarea matInput #message name="metodologia" cdkTextareaAutosize #autosize="cdkTextareaAutosize"
                cdkAutosizeMinRows="8" maxlength="4000" [(ngModel)]="atividade.descricaoMetodologia" [disabled]="campoDesabilitado">
                 </textarea>
            <mat-hint align="end">{{message.value.length}} / 4000</mat-hint>
        </mat-form-field>
    </div>
    
    <div fxLayout="row" fxFlex="46%" fxLayoutGap="25px" fxFlexFill>
        <div ngModelGroup="comboContrato" fxLayoutGap="20px" fxFlex="100">
            <combo-percurso [showDisplayId]="false"
                            [obrigatorio]="false"
                            [selecionado]="atividade.percurso"
                            (valorChange)="onValorChangePercurso($event)"
                            [desabilitado]="campoDesabilitado">
            </combo-percurso>
        </div>
    </div> 
</div>

<div fxLayout="row" fxFlexFill>
    <div ngModelGroup="acoesAtividade" fxFlex="100%">
        <publico-alvo-atividade [oficina]="atividade"></publico-alvo-atividade>
    </div>
</div>

 <div fxLayout="row" fxLayoutGap="50px" style="margin-top: 10px; margin-bottom: 10px" fxFlexFill>

     <!-- DATA -->
     <div id="coluna1" fxFlex="60%">
         <mat-toolbar class="titulopartes">Data</mat-toolbar>
         <div fxLayout="row" fxLayoutGap="50px" style="margin-top: 10px; margin-bottom: 10px" fxFlexFill>
             <mat-form-field fxFlex="40%" fxFlexOffset="20px">
                 <input matInput 
                        name="dataInicio" 
                        [matDatepicker]="dataInicio" 
                        placeholder="Data de Início"
                        required
                        [(ngModel)]="atividade.dataInicio" (input)="onMascaraDataInput($event)">
                 <mat-datepicker-toggle matSuffix [for]="dataInicio"></mat-datepicker-toggle>
                 <mat-datepicker #dataInicio></mat-datepicker>
             </mat-form-field>

             <mat-form-field fxFlex="40%" fxFlexOffset="20px">
                 <input matInput 
                        name="dataFim" 
                        required
                        [matDatepicker]="dataFim" 
                        placeholder="Data Fim"
                        [(ngModel)]="atividade.dataFim" (input)="onMascaraDataInput($event)">
                 <mat-datepicker-toggle matSuffix [for]="dataFim"></mat-datepicker-toggle>
                 <mat-datepicker #dataFim></mat-datepicker>
             </mat-form-field>
         </div>
     </div>

 </div>

 <!-- DADOS BÁSICOS -->
 <mat-toolbar class="titulopartes">Dados Básicos</mat-toolbar>
 <div fxLayout="row" fxLayoutAlign="space-between center" style="margin-top: 10px; margin-bottom: 10px"
     fxFlexFill>

     <!-- LOCAL EXECUÇÃO-->
     <div fxFlex="15%">
         <div fxLayout="row">
             <mat-form-field fxFlexOffset="20px">
                 <mat-label>Local de Execução</mat-label>
                 <mat-select [(ngModel)]="atividade.localExecucao" name="localExecucao">
                    <mat-option></mat-option>
                     <mat-option *ngFor="let u of localExecucao" [value]="u.id">
                         {{u.descricao}}
                     </mat-option>
                 </mat-select>
             </mat-form-field>
         </div>
     </div>


     <!-- HORARIO INICIO -->
     <div fxFlex="15%">
         <div fxLayout="row" fxFlexFill>
             <mat-form-field>
                 <input matInput #horaInicio="ngModel" 
                        mat-hide-icons="calendar" 
                        type="time" 
                        name="horaInicio"
                        placeholder="Hora Início"
                        required 
                        [(ngModel)]="atividade.horaInicio">
             </mat-form-field>
         </div>
     </div>

     <!-- HORARIO FIM -->
     <div fxFlex="15%">
         <div fxLayout="row" fxFlexFill>
             <mat-form-field>
                 <input matInput 
                        #horaFim="ngModel" 
                        mat-hide-icons="calendar" 
                        type="time" name="horaFim"
                        placeholder="Hora Fim" 
                        required
                        [(ngModel)]="atividade.horaFim">
             </mat-form-field>
         </div>
     </div>


     <!-- CARGA HORÁRIA -->
     <div fxFlex="20%">
         <div fxLayout="row">
            <mat-form-field fxFlex="33%">
                <input [ngModelOptions]="{standalone: true}" 
                    matInput [textMask]="{mask: mascaraHorario}" placeholder="Carga Horária"
                    type="text" [ngModel]="atividade.cargaHoraria | formatTimeHHMM"
                    (ngModelChange)="onTimeChange($event)">
            </mat-form-field>
         </div>
     </div>

 </div>

 <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="50px"
     style="margin-top: 10px; margin-bottom: 10px" fxFlexFill>
     <div fxFlex="15%">
         <div fxLayout="row">
             <mat-form-field fxFlexOffset="20px" fxFlex="85%">
                 <input matInput type="number" name="maximoParticipantes" placeholder="Máximo Participantes"
                     [(ngModel)]="atividade.maximoParticipantes">
             </mat-form-field>
         </div>
     </div>

     <div fxFlex="75%">
         <div fxLayout="row" fxLayoutGap="20px">
             <div fxFlex="50%">
                 <label>Dias:</label>
             </div>
             <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px"
                  [ngClass]="{'invalid': hasDiaSemana()}"
                  style="margin-top: 10px; margin-bottom: 10px" fxFlexFill>
                 <mat-slide-toggle name="segunda" [(ngModel)]="atividade.segunda" [required]="hasDiaSemana()">SEG</mat-slide-toggle>
                 <mat-slide-toggle name="terca"   [(ngModel)]="atividade.terca"   [required]="hasDiaSemana()">TER</mat-slide-toggle>
                 <mat-slide-toggle name="quarta"  [(ngModel)]="atividade.quarta"  [required]="hasDiaSemana()">QUA</mat-slide-toggle>
                 <mat-slide-toggle name="quinta"  [(ngModel)]="atividade.quinta"  [required]="hasDiaSemana()">QUI</mat-slide-toggle>
                 <mat-slide-toggle name="sexta"   [(ngModel)]="atividade.sexta"   [required]="hasDiaSemana()">SEX</mat-slide-toggle>
                 <mat-slide-toggle name="sabado"  [(ngModel)]="atividade.sabado"  [required]="hasDiaSemana()">SAB</mat-slide-toggle>
                 <mat-slide-toggle name="domingo" [(ngModel)]="atividade.domingo" [required]="hasDiaSemana()">DOM</mat-slide-toggle>
             </div>
         </div>
     </div>
 </div>

 <!-- OBJETIVOS DA ATIVIDADE -->
<!-- <mat-toolbar class="titulopartes">Objetivos</mat-toolbar>
<div fxLayout="row" fxFlexFill>
    <div fxFlex="100%" ngModelGroup="grupoObjetivoAtividade" style="margin-top: 10px; margin-bottom: 10px">
        <div *ngFor="let objetivoAtividade of atividade.objetivosAtividade; let index = index">
            <formulario-meta-objetivo-turma [objetivoAtividade]="objetivoAtividade"
                                      [index]="index"
                                      [objetivosAtividade]="atividade.objetivosAtividade"
                                      [perfilAcesso]="perfilAcesso">
            </formulario-meta-objetivo-turma>
        </div>
        <div *ngIf="perfilAcesso.insere" fxLayoutAlign="start center" fxLayoutGap="16px"
             style="padding-top: 10px; padding-left: 20px;">
            <div>
                <button matTooltip="Novo Objetivo" mat-mini-fab color="primary" (click)="addObjetivoAtividade()"
                        style="width: 175px;border-radius: 5px;">
                    <mat-icon>add</mat-icon>
                    Objetivo Institucional
                </button>
            </div>
        </div>
    </div>
</div> -->
 
 <div fxLayout="row" 
      fxLayoutGap="50px" style="margin-top: 10px; margin-bottom: 10px" 
      fxFlexFill
      *ngIf="mostrarCampos">
    
     <!-- PROJETO -->
     <div fxLayout="column" fxFlex="50%">
         <mat-toolbar class="titulopartes">Projeto</mat-toolbar>
         <mat-form-field style="margin-left: 20px">
             <mat-label>Projetos:</mat-label>
             <mat-select [(ngModel)]="atividade.projeto.id" name="projeto">
                <mat-option></mat-option>
                 <mat-option *ngFor="let u of projetos" [value]="u.id">
                     {{u.nome}}
                 </mat-option>
             </mat-select>
             <mat-hint *ngIf="projetos?.length === 0" align="start">Nenhum projeto cadastrado</mat-hint>
         </mat-form-field>
     </div>

     <!-- PROGRAMA -->
     <div fxLayout="column" fxFlex="50%">
        <mat-toolbar class="titulopartes">Programa</mat-toolbar>
        <mat-form-field style="margin-left: 20px">
            <mat-label>Programas:</mat-label>
            <mat-select [(ngModel)]="atividade.programa.id" name="programa">
                <mat-option></mat-option>
                <mat-option *ngFor="let u of programas" [value]="u.id">
                    {{u.nome}}
                </mat-option>
            </mat-select>
            <mat-hint *ngIf="programas?.length === 0" align="start">Nenhum programa cadastrado</mat-hint>
        </mat-form-field>
    </div>

 </div>


